import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';
import { RouteComponentProps } from 'react-router-dom';
import { IAuthContext } from '../context/auth/auth-context';
import withAuthContext from '../context/auth/AuthConsumer';
import PaperContainer from '../components/PaperContainer';
import { Doughnut } from 'react-chartjs-2';
import axios from 'axios';
import { CeresLogger } from '../logger';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// @ts-ignore
import createFilterOptions from 'react-select-fast-filter-options';
import './react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import { Row, Col } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import { CorporateSelect, HeaderRow, ResultContainer } from '../components/custom-styled-components/CommonStyledComponents';
import { API_BASE_URL, API_AUTH_HEADERS } from '../util/api.util';
import ReactGA from 'react-ga4';
// import any from 'ramda/es/any';

const PageRoot = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ContentInner = styled.div`
  margin: 4em 5em;
  box-sizing: border-box;
`;


const GlassCard = styled(PaperContainer)<{ $expanded?: boolean }>`
  background: rgba(10, 10, 12, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 1.15rem 1.25rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
  backdrop-filter: blur(10px);
  margin-bottom: ${(p) => (p.$expanded ? '12rem' : '1.25rem')};
  transition: margin-bottom 0.2s ease;
`;

const StyledDataTable = styled(DataTable)`
  & > * {
    height: auto;
  }
  & .rdt_TableCell {
    font-size: 10px;
    padding: 3px;
    justify-content: center;
  }
  & .rdt_TableCol {
    justify-content: center;
  }
  /* & .sc-kxynE:first-child {
    background-color: orange ;
  } */
  & .rdt_TableBody {
    overflow-y: initial;
  }
  & .rdt_TableHeader {
    min-height: 0px;
  }
  & .rdt_TableRow {
    min-height: 30px;
  }
  & .rdt_TableHeadRow {
    min-height: 30px;
    background-color: rgba(15, 23, 42, 0.85);
    color: #f8fafc;
  }
  & .rdt_Pagination {
    justify-content: center;
    background: rgba(10, 10, 12, 0.72);
    color: #e2e8f0;
  }
`;
const TableContainer = styled.div`
  margin-top: 1rem;
  width: 100%;
`;

const TableHeading = styled.div`
  display: flex;
  justify-content: center;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
  color: #f1f5f9;
  padding: 0.45rem;
`;

const H3 = styled.div`
  text-align: center;
  text-transform: capitalize;
  font-weight: 600;
  font-size: 1.1rem;
  color: #f8fafc;
`;

const ERC = styled.div`
  text-align: center;
  text-transform: capitalize;
  font-weight: 600;
  font-size: 2em;
  color: #5eead4;
`;

const GeneratorNotes = styled.div`
  margin: 1.25rem auto 0;
  padding-bottom: 0%;
  font-size: 12px;
  font-weight: 600;
  color: #cbd5e1;
`;

const P = styled.div`
  margin-bottom: 0.1rem;
`;

const Generator: React.FC<
  RouteComponentProps<any> & {
    context: IAuthContext;
  }
> = (props) => {
  const vocObjects = [
    'voc_fugitive_controlled_table',
    'voc_stack_uncontrolled_table',
    'voc_fugitive_uncontrolled_table',
  ];
  const noxObjects = [
    'nox_boilers_heaters_controlled_table',
    'nox_engines_turbines_controlled_table',
    'nox_boilers_heaters_uncontrolled_table',
  ];
  const vocLabels = ['VOC Controlled', 'VOC Uncontrolled Stack', 'VOC Uncontrolled Fugutive'];
  const noxLabels = ['NOx Controlled Burners', 'NOx Engines & Turbines', 'NOx Uncontrolled Burners'];
  const [chartType, setChartType] = useState<'voc' | 'nox' | null>(null);
  const [activeData, setActiveData] = useState<any[]>([]);
  const [chartIndex, setChartIndex] = useState<number>(0);
  const [options, setOptions] = useState<any[]>([]);
  const [entity, setEntity] = useState<any>(null);
  const [filter, setFilter] = useState<any>(null);
  const [statsResult, setStatsResult] = useState<any>(null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [entityMenuOpen, setEntityMenuOpen] = useState(false);

  const resetGeneratorState = () => {
    setStatsResult(null);
    setActiveData([]);
    setChartType(null);
    setChartIndex(0);
  };
  const getGenNames = () => {
    try {
      axios
        .get(
          API_BASE_URL + '/api/eventEmissions/genNames',
          // 'http://localhost:5000/ceres-platform-test/us-central1/api/eventEmissions/genNames',

          {
            headers: API_AUTH_HEADERS,
          }
        )
        .then((response) => {
          const resultRecords = response.data[0].jsonlistb;
          setFilter(() => createFilterOptions({ options: resultRecords }));
          setOptions(resultRecords);
          const filterData: any = queryString.parse(props.history.location.search);
          if (filterData.rn) {
            const entityFilterRecord = searchParam(resultRecords, filterData.rn);
            setEntity(entityFilterRecord);
            fetchGenStats(entityFilterRecord.value);
          }
          setIsDisabled(false);
        })
        .catch((err) => {
          CeresLogger.error(err as any);
        })
        .finally();
    } catch (e) {
      CeresLogger.error(e as any);
    }
  };
  const searchParam = (data: any, value: any): any => {
    for (const aData of data) {
      if (aData.value === value) {
        return aData;
      }
    }
  };
  let vocEvents = {};
  let noxEvents = {};
  let dataOptions = {};
  const fetchGenStats = (value: any) => {
    setIsDisabled(true);
    try {
      axios
        .post(
          API_BASE_URL + '/api/fetchGenStats',
          // 'http://localhost:5000/ceres-platform-test/us-central1/api/fetchGenStats',
          { RN: value },
          {
            headers: API_AUTH_HEADERS,
          }
        )
        .then((response) => {
          setActiveData([]);
          setStatsResult(response.data[0].ero_json_2018);
          setIsDisabled(false);
        })
        .catch((err) => {
          CeresLogger.error(err as any);
        })
        .finally();
    } catch (e) {
      CeresLogger.error(e as any);
    }
  };

  const chartCalculations = (first: number, second: number, third: number): any => {
    if (first < 1 || second < 1 || third < 1) {
      const maxNum = Math.max(first, second, third);
      if (maxNum > 0) {
        if (first < 1 && first > 0) {
          first = 1;
        }
        if (second < 1 && second > 0) {
          second = 1;
        }
        if (third < 1 && third > 0) {
          third = 1;
        }
        if (first === maxNum) {
          first = 100 - second - third;
        } else if (second === maxNum) {
          second = 100 - first - third;
        } else if (third === maxNum) {
          third = 100 - first - second;
        }
      }
    }
    return { first, second, third };
  };

  const Chart = require('react-chartjs-2').Chart;
  const originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
  Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
    draw() {
      originalDoughnutDraw.apply(this, arguments);

      const chart = this.chart;
      const width = chart.width;
      const height = chart.chartArea.bottom;
      const ctx = chart.ctx;
      const fontSize = (height / 500).toFixed(2);
      ctx.font = `${fontSize}em sans-serif`;
      ctx.textBaseline = 'middle';
      ctx.color = '#000';
      const total = chart.config.data.total;
      const text = total + ` TONS`;
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillText(text, textX, textY);
    },
  });
  if (statsResult) {
    const vocPercentage = chartCalculations(
      statsResult.voc_pie.voc_controlled_percentage,
      statsResult.voc_pie.voc_stack_uncontrolled_percentage,
      statsResult.voc_pie.voc_fugitive_uncontrolled_percentage
    );

    vocEvents = {
      labels: ['Controlled', 'Uncontrolled Stack', 'Uncontrolled Fugutive'],
      total: statsResult.voc_pie.voc_total_tons,
      original: [
        statsResult.voc_pie.voc_controlled_percentage,
        statsResult.voc_pie.voc_stack_uncontrolled_percentage,
        statsResult.voc_pie.voc_fugitive_uncontrolled_percentage,
      ],
      datasets: [
        {
          label: 'Voc Events',
          backgroundColor: ['#00BFFF', '#FF0000', '#FF6961'],
          hoverBorderColor: 'Black',
          hoverBorderWidth: '5px',
          weight: 9,
          data: [vocPercentage.first, vocPercentage.second, vocPercentage.third],
        },
      ],
    };

    const noxPercentage = chartCalculations(
      statsResult.nox_pie.nox_boilers_heaters_controlled_percentage,
      statsResult.nox_pie.nox_engines_turbines_controlled_percentage,
      statsResult.nox_pie.nox_boilers_heaters_uncontrolled_percentage
    );

    noxEvents = {
      labels: ['Controlled Burners', 'Engines & Turbines', 'Uncontrolled Burners'],
      total: statsResult.nox_pie.nox_total_tons,
      original: [
        statsResult.nox_pie.nox_boilers_heaters_controlled_percentage,
        statsResult.nox_pie.nox_engines_turbines_controlled_percentage,
        statsResult.nox_pie.nox_boilers_heaters_uncontrolled_percentage,
      ],
      datasets: [
        {
          label: 'Nox Events',
          backgroundColor: ['#00BFFF', '#808080', '#FF0000'],
          hoverBorderColor: 'Black',
          hoverBorderWidth: '5px',
          weight: 9,
          data: [noxPercentage.first, noxPercentage.second, noxPercentage.third],
        },
      ],
    };
    dataOptions = {
      responsive: true,
      maintainAspectRatio: true,
      cutoutPercentage: 40,
      legend: {
        position: 'bottom',
        onClick: null,
      },
      tooltips: {
        bodyAlign: 'center',
        bodyFontSize: 15,
        bodySpacing: 10,
        callbacks: {
          title: (tooltipItem: any, data: any) => {
            return '';
          },
          label: (tooltipItem: any, data: any) => {
            return data.labels[tooltipItem.index];
          },
          afterLabel: (tooltipItem: any, data: any) => {
            const percent = data.original[tooltipItem.index];
            let total: string = ((data.total / 100) * percent).toFixed(2);
            if (total === '0.00') {
              total = '< ' + 0.01;
            }
            return total + ' tons\n' + percent + '%';
          },
        },
      },
    };
  }
  useEffect(() => {
    getGenNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const vocData = [...activeData];
  const columns = [
    {
      name: 'FIN',
      selector: 'FIN',
    },
    {
      name: 'FIN Name',
      selector: 'FIN Name',
    },
    {
      name: 'FIN Group',
      selector: 'FIN Group',
    },
    {
      name: 'FIN Profile',
      selector: 'FIN Profile',
    },
    {
      name: 'EPN',
      selector: 'EPN',
    },
    {
      name: 'EPN Name',
      selector: 'EPN Name',
    },
    {
      name: 'EPN Profile',
      selector: 'EPN Profile',
    },
    {
      name: 'Year',
      selector: 'Year',
    },
    {
      name: 'VOC',
      selector: 'VOC',
    },
    {
      name: 'CIN',
      selector: 'CIN',
    },
    {
      name: 'CIN Name',
      selector: 'CIN Name',
    },
    {
      name: 'CIN Abatement Type',
      selector: 'CIN Abatement Type',
    },
    {
      name: 'Number of Units',
      selector: 'Number of Units',
    },
    {
      name: 'VOC Percent',
      selector: 'voc_percent',
    },
  ];
  const noxData = [...activeData];
  const noxColumns = [
    {
      name: 'FIN',
      selector: 'FIN',
    },
    {
      name: 'FIN Name',
      selector: 'FIN Name',
    },
    {
      name: 'FIN Group',
      selector: 'FIN Group',
    },
    {
      name: 'FIN Profile',
      selector: 'FIN Profile',
    },
    {
      name: 'EPN',
      selector: 'EPN',
    },
    {
      name: 'EPN Name',
      selector: 'EPN Name',
    },
    {
      name: 'Year',
      selector: 'Year',
    },
    {
      name: 'NOx',
      selector: 'NOx',
    },
    {
      name: 'CIN Abatement Type',
      selector: 'CIN Abatement Type',
    },
    // {
    //   name: 'NOx Percent',
    //   selector: 'nox_percent'
    // },
    {
      name: 'Heat Input',
      selector: 'Heat Input',
    },
    {
      name: 'Heat Input Units',
      selector: 'Heat Input Units',
    },
    {
      name: 'NOx Emission factor',
      selector: 'NOx Emission factor',
    },
    {
      name: 'Factor Units',
      selector: 'Factor Units',
    },
  ];

  return (
    <PageRoot className="generator-page">
      <ContentInner>
        <p className="kicker">Generator</p>
        <h1 className="validator-title">Potential <em className="em-css">emissions</em> reduction opportunities</h1>
        <h2 className="validator-subtitle">VOC and NOx opportunity analysis by registered entity</h2>
        {!!isDisabled && (
          <HeaderRow>
            <div>
              <Spinner animation="border" size="sm" style={{ color: '#34d399' }} />
            </div>
          </HeaderRow>
        )}
        <GlassCard $expanded={entityMenuOpen}>
          <CorporateSelect
            value={entity}
            className="basic-single"
            filterOptions={filter}
            disabled={isDisabled}
            name="corporate1"
            options={options}
            onFocus={() => setEntityMenuOpen(true)}
            onBlur={() => setEntityMenuOpen(false)}
            onChange={(e: any) => {
              setEntityMenuOpen(false);
              setEntity(e);
              if (e) {
                fetchGenStats(e.value);
                ReactGA.event({
                  category: 'Search',
                  action: 'Generator RN Search',
                  label: e.value // Optional: log the value the user typed
                });
              } else {
                resetGeneratorState();
              }
            }}
          />
        </GlassCard>
        {statsResult && (
          <GlassCard>
            <ResultContainer>
              <Row>
                <Col md={12}>
                  <ERC>ERC Value: ${statsResult.erc_value.amount}* </ERC>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <H3>VOC</H3>
                  <Doughnut
                    data={vocEvents}
                    options={dataOptions}
                    onElementsClick={(elems) => {
                      if (elems[0]) {
                        setActiveData(statsResult[vocObjects[elems[0]._index]]);
                        setChartIndex(elems[0]._index);
                        setChartType('voc');
                      }
                    }}
                  />
                </Col>
                <Col md={6}>
                  <H3>NOx</H3>
                  <Doughnut
                    data={noxEvents}
                    options={dataOptions}
                    onElementsClick={(elems) => {
                      if (elems[0]) {
                        setActiveData(statsResult[noxObjects[elems[0]._index]]);
                        setChartIndex(elems[0]._index);
                        setChartType('nox');
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <GeneratorNotes>
                  <P>*Based on Texas Commission on Environmental Quality 2018 Emissions Inventory Information</P>
                  <P>
                    *Uncontrolled / Undercontrolled based on <span>&#8805;</span> 0.02 NOx control,<span>&#60;</span>
                    70% VOC stack control and <span>&#60;</span>70% VOC fugitive control
                  </P>
                  <P>
                    *ERC value based on $100k assuming additional 50% reduction of uncontrolled fugitives, 99% reduction
                    of controlled stack and 75% reduction of uncontrolled burners{' '}
                  </P>
                </GeneratorNotes>
              </Row>
            </ResultContainer>
          </GlassCard>
        )}
        {activeData.length > 0 && chartType === 'voc' && (
          <GlassCard>
            <ResultContainer>
              <TableHeading>
                <h6>{vocLabels[chartIndex]}</h6>
              </TableHeading>
              <TableContainer>
                <StyledDataTable
                  columns={columns}
                  data={vocData}
                  pagination
                  striped={true}
                  highlightOnHover={true}
                  responsive={true}
                />
              </TableContainer>
            </ResultContainer>
          </GlassCard>
        )}
        {activeData.length > 0 && chartType === 'nox' && (
          <GlassCard>
            <ResultContainer>
              <TableHeading>
                <h6>{noxLabels[chartIndex]}</h6>
              </TableHeading>
              <TableContainer>
                <StyledDataTable
                  columns={noxColumns}
                  data={noxData}
                  pagination
                  striped={true}
                  highlightOnHover={true}
                  responsive={true}
                />
              </TableContainer>
            </ResultContainer>
          </GlassCard>
        )}
      </ContentInner>
    </PageRoot>
  );
};

export default withAuthContext(Generator);
